import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'

import { Form, Step, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'
import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../services/redirect'
import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'

import { DropdownComponent } from '../../components/options'
import { ValidateForm } from '../../validations/schemaReservation'


export default function ReservationComponent(props){

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  const roomOptions = [
    { key: '1', value: 'Select room', text: 'Select room' },
    { key: '2', value: 'Standard Deluxe', text: 'Standard Deluxe' },
    { key: '3', value: 'Bridal Room', text: 'Bridal Room' },
    { key: '4', value: 'Deluxe Room', text: 'Deluxe Room' },
    { key: '5', value: 'Family Room', text: 'Family Room' },
    { key: '6', value: 'Premium Room', text: 'Premium Room' },
  ]

  const [state, setstate] = useState({
    checkin_date:'',
    checkout_date:'',
    date_min:'',
    checkin_time:'',
    room_name:'Select room',
    name:'',
    phone_number:'',
    email:'',
    address:'',
    message:''
  });


  function handleSubmitForm(values, props){

    if(values.room_name=='Select room'){
      var objRoomName = {room_name:"This field is required."};
      Object.keys(objRoomName).forEach(function(key) {
        props.setErrors(objRoomName);
      });
      return false;
    }

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let value ={
      checkin_date:values.checkin_date!=''?moment(new Date(values.checkin_date)).format('MMMM DD, YYYY'):'',
      checkout_date:values.checkout_date!=''?moment(new Date(values.checkout_date)).format('MMMM DD, YYYY'):'',
      checkin_time:values.checkin_time,
      room_name:values.room_name,
      name:values.name,
      phone_number:values.phone_number,
      email:values.email,
      address:values.address,
      message:values.message,
    }

    let formData = new FormData();
    formData.append('type','reservation');
    formData.append('info',JSON.stringify(value));
    axios.post('/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        props.resetForm();
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Reservation successfully sent.'}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
        },2000);
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Error Reservation!',text:'Reservation not successfully sent.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });
      

    })
    .catch(function (error){
      console.log(error);
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  function SetDateToday(){
    var date_selected 	= moment(new Date()).format('MMMM DD, YYYY');
    var date_mindate 	  = moment(new Date(date_selected)).add(1, 'days');
    setstate({
      ...state,
      checkin_date:date_selected,
      checkout_date:moment(new Date(date_mindate)).format('MMMM DD, YYYY'),
      date_min:new Date(date_mindate)
    });
  }

  useEffect(()=>{
    SetDateToday();
  },[]);


  return (
    <React.Fragment>


      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


      <Formik
        enableReinitialize
        initialValues={state}
        onSubmit={handleSubmitForm}
        validationSchema={ValidateForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

        const CustomCheckInDate = ({ value, onClick }) => (
          <Input iconPosition='left' onClick={onClick} value={values.checkin_date}><Icon name='uil-calender icon' /><input /></Input>
        );

        const CustomCheckOutDate = ({ value, onClick }) => (
          <Input iconPosition='left' onClick={onClick} value={values.checkout_date}><Icon name='uil-calender icon' /><input /></Input>
        );



        return(
            <div className="main foods">
                <section>
                  <div className="wrapper boxFormWrapper">
                    
                    <div>
                      <div>
                        <img id="roomsIcon" className="svgIcons" src="https://coffeeshophotel.com/imgs/reservation-logo.svg" alt="Hotel Reservation. " title="Hotel Reservation"/>
                      </div>
                    </div>

                    <div className="fancyBox">
                       <Form>

                         <div className="boxForm-container">
                            <div><label>Check-In Date</label></div>
                            <div>
                            <Form.Group widths="equal">
                              <Field name="checkin_date">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <DatePicker
                                      showYearDropdown
                                      yearDropdownItemNumber={100}
                                      scrollableYearDropdown
                                      showMonthDropdown
                                      dropdownMode="select"
                                      selected={values.checkin_date!=''?new Date(values.checkin_date):null}
                                      onChange={date => {
                                        var dateselected 	= moment(new Date(date)).format('MMMM DD, YYYY');
                                        var formindate 		= moment(new Date(date)).add(1, 'days');
                                        var checkout_date = moment(new Date(formindate)).format('MMMM DD, YYYY');

                                        setFieldValue('date_min',new Date(formindate));
                                        setFieldValue('checkin_date',dateselected);
                                        setFieldValue('checkout_date',checkout_date);


                                      }}
                                      customInput={<CustomCheckInDate />}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>


                         <div className="boxForm-container">
                            <div><label>Check-Out Date</label></div>
                            <div>
                            <Form.Group widths="equal">
                              <Field name="checkout_date">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <DatePicker
                                      showYearDropdown
                                      yearDropdownItemNumber={100}
                                      scrollableYearDropdown
                                      showMonthDropdown
                                      dropdownMode="select"
                                      selected={values.checkout_date!=''?new Date(values.checkout_date):null}
                                      minDate={values.date_min}
                                      onChange={date => {
                                        var date_selected 	= moment(new Date(date)).format('MMMM DD, YYYY');
                                        setFieldValue(field.name,date_selected);
                                      }}
                                      customInput={<CustomCheckOutDate />}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>

                         <div className="boxForm-container">
                            <div><label>Check-In Time</label></div>
                            <div>
                            <Form.Group widths="equal">
                                <Field name="checkin_time">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <Input {...field} onChange={handleChange}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                             <p style={{'color':'#fff','margin-bottom':'10px'}}>Note: Check-in time from to 2PM</p>
                            </div>
                         </div>

                         <div className="boxForm-container">
                            <div><label>Room</label></div>
                            <div>
                            <Form.Group widths="equal">
                              <Field name="room_name">
                                {({ field, form }) => (
                                    <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <Select selectOnBlur={false}
                                          {...field}
                                          options={roomOptions}
                                          onChange={(e, { value }) => {
                                            setFieldValue(field.name,value);
                                          }}/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                )}
                              </Field>
                            </Form.Group>
                            </div>
                         </div>

                         <div className="boxForm-container">
                            <div><label>Name</label></div>
                            <div>
                            <Form.Group widths="equal">
                                <Field name="name">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <Input {...field} onChange={handleChange}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>

                         <div className="boxForm-container">
                            <div><label>Phone Number</label></div>
                            <div>
                            <Form.Group widths="equal">
                                <Field name="phone_number">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <Cleave {...field} onChange={handleChange} options={{numericOnly: true}} maxLength="11"/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>

                         <div className="boxForm-container">
                            <div><label>Email Address</label></div>
                            <div>
                            <Form.Group widths="equal">
                                <Field name="email">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <Input {...field} onChange={handleChange}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>


                         <div className="boxForm-container">
                            <div><label>Address</label></div>
                            <div>
                            <Form.Group widths="equal">
                                <Field name="address">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <Input {...field} onChange={handleChange}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>


                         <div className="boxForm-container">
                            <div><label>Other Instructions</label></div>
                            <div>
                            <Form.Group widths="equal">
                                <Field name="message">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <TextArea {...field} onChange={handleChange}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                             </Form.Group>
                            </div>
                         </div>

                         <div className="boxForm-container">
                            <div></div>
                            <div>
                              <Button className='PrimaryButton strong' content='Send Reservation' onClick={handleSubmit}/>
                            </div>
                          </div>

    
                        </Form>
                    </div>

                  </div>
                </section>
              </div>
        
        )}}/>
    </React.Fragment>
  ) 
}
